import { render, staticRenderFns } from "./annualWage.vue?vue&type=template&id=28e027ad&scoped=true&"
import script from "./annualWage.vue?vue&type=script&lang=js&"
export * from "./annualWage.vue?vue&type=script&lang=js&"
import style0 from "./annualWage.vue?vue&type=style&index=0&id=28e027ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e027ad",
  null
  
)

export default component.exports